/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  Address,
  AddressToJSON,
  FetchBillingResponse,
  FetchBillingResponseFromJSON,
  InlineResponse200,
  InlineResponse200FromJSON,
  PayByAchRequestBody,
  PayByAchRequestBodyToJSON,
  Payment,
  PaymentOptions,
  PaymentOptionsFromJSON,
  PaymentResponse,
  PaymentResponseFromJSON,
  PaymentStartRequestBody,
  PaymentStartRequestBodyToJSON,
  PaymentToJSON,
  ValidateAchRoutingNumber,
  ValidateAchRoutingNumberFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface DeletePaymentRequest extends runtime.BaseRequestParameters {
  paymentKey: number
}

export interface FetchBillingRequest extends runtime.BaseRequestParameters {
  userKey?: number
  generateReport?: boolean
}

export interface FetchPaymentOptionsRequest
  extends runtime.BaseRequestParameters {
  userKey: number
}

export interface PayByAchRequest extends runtime.BaseRequestParameters {
  paymentKey: number
  body?: PayByAchRequestBody
}

export interface StartPaymentRequest extends runtime.BaseRequestParameters {
  userKey?: number
  generateReport?: boolean
  body?: PaymentStartRequestBody
}

export interface UpdatePaymentRequest extends runtime.BaseRequestParameters {
  body?: Payment
}

export interface UpdatePaymentAddressRequest
  extends runtime.BaseRequestParameters {
  paymentKey: number
  body?: Address
}

export interface ValidateAchRoutingNumberRequest
  extends runtime.BaseRequestParameters {
  routingNumber: string
}

/**
 *
 */
export class PaymentsApi extends runtime.BaseAPI {
  /**
   *        Delete manual payment for Enrollment or Licensing fees.       Requester must possess a Payment/deleteEnrollmentPayment grant or a deleteLicensingPayment grant in order to delete payments related to enrollment, else a 403 will be returned.
   * Delete a manually entered payment by paymentKey
   */
  async deletePaymentRaw(
    requestParameters: DeletePaymentRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.paymentKey === null ||
      requestParameters.paymentKey === undefined
    ) {
      throw new runtime.RequiredError(
        'paymentKey',
        'Required parameter requestParameters.paymentKey was null or undefined when calling deletePayment.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment/{paymentKey}`.replace(
        `{${'paymentKey'}}`,
        encodeURIComponent(String(requestParameters.paymentKey))
      ),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   *        Delete manual payment for Enrollment or Licensing fees.       Requester must possess a Payment/deleteEnrollmentPayment grant or a deleteLicensingPayment grant in order to delete payments related to enrollment, else a 403 will be returned.
   * Delete a manually entered payment by paymentKey
   */
  async deletePayment(requestParameters: DeletePaymentRequest): Promise<void> {
    await this.deletePaymentRaw(requestParameters)
  }

  /**
   * Calculates any licensing or enrollment payments owed. Returns those alongside payment transaction history.  Bills are identified by the `for` field. Enrollment payments are made for a set of student-in-program pairs; licensing payments are for a specific program.  An optional query parameter for `userKey` may be specified. The lack of this will return billing results for the current logged in requester. When adding the query parameter, billing results are returned for the specified userKey, given the requester has proper permissions.  ## PERMISSIONS: - The requester does not need any specific if no `userKey` query parameter is specified or the specified `userKey` matched the requester\'s userKey. - To view the billing info for anyone but the requesting user themselves requires permission both to view payments and to view the user in question. specifically:   - A Payment/view grant is required, else a 403 error will be returned.   - A User/view[their team\'s] grant will allow the requester to see the user\'s billing results if they are in the requester\'s downline team.   - A User/view[any] grant will allow the requester to see the billing results of any user in the system.
   * Get current enrollment and licensing bills and related transaction history in preparation for paying a bill
   */
  async fetchBillingRaw(
    requestParameters: FetchBillingRequest
  ): Promise<runtime.ApiResponse<FetchBillingResponse>> {
    const queryParameters: any = {}

    if (requestParameters.userKey !== undefined) {
      queryParameters['userKey'] = requestParameters.userKey
    }

    if (requestParameters.generateReport !== undefined) {
      queryParameters['generateReport'] = requestParameters.generateReport
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/billing`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchBillingResponseFromJSON(jsonValue)
    )
  }

  /**
   * Calculates any licensing or enrollment payments owed. Returns those alongside payment transaction history.  Bills are identified by the `for` field. Enrollment payments are made for a set of student-in-program pairs; licensing payments are for a specific program.  An optional query parameter for `userKey` may be specified. The lack of this will return billing results for the current logged in requester. When adding the query parameter, billing results are returned for the specified userKey, given the requester has proper permissions.  ## PERMISSIONS: - The requester does not need any specific if no `userKey` query parameter is specified or the specified `userKey` matched the requester\'s userKey. - To view the billing info for anyone but the requesting user themselves requires permission both to view payments and to view the user in question. specifically:   - A Payment/view grant is required, else a 403 error will be returned.   - A User/view[their team\'s] grant will allow the requester to see the user\'s billing results if they are in the requester\'s downline team.   - A User/view[any] grant will allow the requester to see the billing results of any user in the system.
   * Get current enrollment and licensing bills and related transaction history in preparation for paying a bill
   */
  async fetchBilling(
    requestParameters: FetchBillingRequest
  ): Promise<FetchBillingResponse> {
    const response = await this.fetchBillingRaw(requestParameters)
    return await response.value()
  }

  /**
   * Returns the options needed for parents to complete paying their enrollment(s).     Only used for parents currently, if an actor calls this endpoint we will return an error.
   * Returns the options needed for parents to complete paying their enrollment(s).
   */
  async fetchEnrollmentBillingPaymentOptionsRaw(
    requestParameters: runtime.BaseRequestParameters
  ): Promise<runtime.ApiResponse<InlineResponse200>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/fetchEnrollmentBillingPaymentOptions`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InlineResponse200FromJSON(jsonValue)
    )
  }

  /**
   * Returns the options needed for parents to complete paying their enrollment(s).     Only used for parents currently, if an actor calls this endpoint we will return an error.
   * Returns the options needed for parents to complete paying their enrollment(s).
   */
  async fetchEnrollmentBillingPaymentOptions(
    requestParameters: runtime.BaseRequestParameters
  ): Promise<InlineResponse200> {
    const response = await this.fetchEnrollmentBillingPaymentOptionsRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   * Provides a list of all programs user directs and list enrollments user has children enrolled in.       Takes a userKey in as a URL param.       Requires the user have updateEnrollmentPayment, updateLicensingPayment, view Program and view Enrollment grants.
   * List of all programs and enrollments that the user can create/edit payments for.
   */
  async fetchPaymentOptionsRaw(
    requestParameters: FetchPaymentOptionsRequest
  ): Promise<runtime.ApiResponse<PaymentOptions>> {
    if (
      requestParameters.userKey === null ||
      requestParameters.userKey === undefined
    ) {
      throw new runtime.RequiredError(
        'userKey',
        'Required parameter requestParameters.userKey was null or undefined when calling fetchPaymentOptions.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment/options/{userKey}`.replace(
        `{${'userKey'}}`,
        encodeURIComponent(String(requestParameters.userKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentOptionsFromJSON(jsonValue)
    )
  }

  /**
   * Provides a list of all programs user directs and list enrollments user has children enrolled in.       Takes a userKey in as a URL param.       Requires the user have updateEnrollmentPayment, updateLicensingPayment, view Program and view Enrollment grants.
   * List of all programs and enrollments that the user can create/edit payments for.
   */
  async fetchPaymentOptions(
    requestParameters: FetchPaymentOptionsRequest
  ): Promise<PaymentOptions> {
    const response = await this.fetchPaymentOptionsRaw(requestParameters)
    return await response.value()
  }

  /**
   * Pay via an ACH provider for a payment in WIP status. Will return the updated payment.  **NOTE:** Be sure to check the resulting `paymentStatus` to see if the payment was successful or not!
   * Pay via an ACH provider.
   */
  async payByAchRaw(
    requestParameters: PayByAchRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>> {
    if (
      requestParameters.paymentKey === null ||
      requestParameters.paymentKey === undefined
    ) {
      throw new runtime.RequiredError(
        'paymentKey',
        'Required parameter requestParameters.paymentKey was null or undefined when calling payByAch.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment/{paymentKey}/ach`.replace(
        `{${'paymentKey'}}`,
        encodeURIComponent(String(requestParameters.paymentKey))
      ),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: PayByAchRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentResponseFromJSON(jsonValue)
    )
  }

  /**
   * Pay via an ACH provider for a payment in WIP status. Will return the updated payment.  **NOTE:** Be sure to check the resulting `paymentStatus` to see if the payment was successful or not!
   * Pay via an ACH provider.
   */
  async payByAch(requestParameters: PayByAchRequest): Promise<PaymentResponse> {
    const response = await this.payByAchRaw(requestParameters)
    return await response.value()
  }

  /**
   *  Create a new payment for Enrollment or Licensing fees, or fees previously incurred due to NSF when making such a payment.   Enrollment payments are made for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided. Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  ## Without `userKey` Query Param (or `userKey === requester userKey`) When the the `userKey` query parameter is not utilized, the payment will be created for the current logged in user.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.  Payments can be made either by ACH or CC (credit card), specified in the `method` property. After validating inputs, will create and return a new WIP payment for either a licensing payment or enrollment payment.  For an Enrollment payment, an ACH discount will be applied to the total. The specified payment amount must match the enrollment bill total minus the ach discount amount, which is retrieved from the `fetchBilling` endpoint.  If the amount due for an enrollment payment is $0, then the newly created Payment will be set to PAID status, and the associated enrollments will be moved directly to ENROLLED status. When a payment is returned from the endpoint, and it is already in PAID status, no other steps of the payment flow will be necessary and a successful enrollment message should be shown to the user making the payment.  ## With `userKey` Query Param An optional query parameter for `userKey` is accepted to allow a user with proper permissions to create a new manually entered payment for another user. The amount provided for the payment can be any number. A negative number will be considered a credit on the user\'s account. A positive number will be considered a payment.  ## PERMISSIONS: - No specific permissions are required for the requester to make payments for their own account. - Requester must have a Payment/createLicensingPayment grant to create a licensing payment for another user. - Requester must have a Payment/createEnrollmentPayment grant to create an enrollment payment for another user.
   * Create a new payment for Enrollment or Licensing fees.
   */
  async startPaymentRaw(
    requestParameters: StartPaymentRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>> {
    const queryParameters: any = {}

    if (requestParameters.userKey !== undefined) {
      queryParameters['userKey'] = requestParameters.userKey
    }

    if (requestParameters.generateReport !== undefined) {
      queryParameters['generateReport'] = requestParameters.generateReport
    }

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: PaymentStartRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentResponseFromJSON(jsonValue)
    )
  }

  /**
   *  Create a new payment for Enrollment or Licensing fees, or fees previously incurred due to NSF when making such a payment.   Enrollment payments are made for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided. Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  ## Without `userKey` Query Param (or `userKey === requester userKey`) When the the `userKey` query parameter is not utilized, the payment will be created for the current logged in user.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.  Payments can be made either by ACH or CC (credit card), specified in the `method` property. After validating inputs, will create and return a new WIP payment for either a licensing payment or enrollment payment.  For an Enrollment payment, an ACH discount will be applied to the total. The specified payment amount must match the enrollment bill total minus the ach discount amount, which is retrieved from the `fetchBilling` endpoint.  If the amount due for an enrollment payment is $0, then the newly created Payment will be set to PAID status, and the associated enrollments will be moved directly to ENROLLED status. When a payment is returned from the endpoint, and it is already in PAID status, no other steps of the payment flow will be necessary and a successful enrollment message should be shown to the user making the payment.  ## With `userKey` Query Param An optional query parameter for `userKey` is accepted to allow a user with proper permissions to create a new manually entered payment for another user. The amount provided for the payment can be any number. A negative number will be considered a credit on the user\'s account. A positive number will be considered a payment.  ## PERMISSIONS: - No specific permissions are required for the requester to make payments for their own account. - Requester must have a Payment/createLicensingPayment grant to create a licensing payment for another user. - Requester must have a Payment/createEnrollmentPayment grant to create an enrollment payment for another user.
   * Create a new payment for Enrollment or Licensing fees.
   */
  async startPayment(
    requestParameters: StartPaymentRequest
  ): Promise<PaymentResponse> {
    const response = await this.startPaymentRaw(requestParameters)
    return await response.value()
  }

  /**
   *  EDit a payment for Enrollment or Licensing fees. After validating inputs, will create and return the updated payment for either a licensing payment or enrollment payment.    Enrollment payments are updated for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided.  Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.
   * Update a payment for Enrollment or Licensing fees.
   */
  async updatePaymentRaw(
    requestParameters: UpdatePaymentRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: PaymentToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentResponseFromJSON(jsonValue)
    )
  }

  /**
   *  EDit a payment for Enrollment or Licensing fees. After validating inputs, will create and return the updated payment for either a licensing payment or enrollment payment.    Enrollment payments are updated for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided.  Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.
   * Update a payment for Enrollment or Licensing fees.
   */
  async updatePayment(
    requestParameters: UpdatePaymentRequest
  ): Promise<PaymentResponse> {
    const response = await this.updatePaymentRaw(requestParameters)
    return await response.value()
  }

  /**
   * Update the billing address for an existing payment.  If the payment is for Enrollment, tax will be calculated from the provided address, updated on the payment record, and returned. Tax will be provided by a third-party service; if that service is unavailable, US addresses will have default state tax rates applied; if everything else fails, tax will be set to 0.  If the payment method is CC on the specified payment, a `ccFormToken` will be returned to be utilized for Authorize.net form iframe. See: https://developer.authorize.net/api/reference/index.html#accept-suite-get-an-accept-payment-page.
   * Update the billing address for an existing payment.
   */
  async updatePaymentAddressRaw(
    requestParameters: UpdatePaymentAddressRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>> {
    if (
      requestParameters.paymentKey === null ||
      requestParameters.paymentKey === undefined
    ) {
      throw new runtime.RequiredError(
        'paymentKey',
        'Required parameter requestParameters.paymentKey was null or undefined when calling updatePaymentAddress.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment/{paymentKey}/address`.replace(
        `{${'paymentKey'}}`,
        encodeURIComponent(String(requestParameters.paymentKey))
      ),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: AddressToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentResponseFromJSON(jsonValue)
    )
  }

  /**
   * Update the billing address for an existing payment.  If the payment is for Enrollment, tax will be calculated from the provided address, updated on the payment record, and returned. Tax will be provided by a third-party service; if that service is unavailable, US addresses will have default state tax rates applied; if everything else fails, tax will be set to 0.  If the payment method is CC on the specified payment, a `ccFormToken` will be returned to be utilized for Authorize.net form iframe. See: https://developer.authorize.net/api/reference/index.html#accept-suite-get-an-accept-payment-page.
   * Update the billing address for an existing payment.
   */
  async updatePaymentAddress(
    requestParameters: UpdatePaymentAddressRequest
  ): Promise<PaymentResponse> {
    const response = await this.updatePaymentAddressRaw(requestParameters)
    return await response.value()
  }

  /**
   * It will return 200 status code with a validRoutingNumber = true or false value respectively.   The endpoint validates if the account routing number is potentially correct by using a mathematical formula.   ABA routing numbers are always nine digits long. The first four specify the routing symbol, the next four identify    the institution and the last is the checksum digit.
   * Validates an ABA routing number.
   */
  async validateAchRoutingNumberRaw(
    requestParameters: ValidateAchRoutingNumberRequest
  ): Promise<runtime.ApiResponse<ValidateAchRoutingNumber>> {
    if (
      requestParameters.routingNumber === null ||
      requestParameters.routingNumber === undefined
    ) {
      throw new runtime.RequiredError(
        'routingNumber',
        'Required parameter requestParameters.routingNumber was null or undefined when calling validateAchRoutingNumber.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payments/routingNumber/{routingNumber}`.replace(
        `{${'routingNumber'}}`,
        encodeURIComponent(String(requestParameters.routingNumber))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ValidateAchRoutingNumberFromJSON(jsonValue)
    )
  }

  /**
   * It will return 200 status code with a validRoutingNumber = true or false value respectively.   The endpoint validates if the account routing number is potentially correct by using a mathematical formula.   ABA routing numbers are always nine digits long. The first four specify the routing symbol, the next four identify    the institution and the last is the checksum digit.
   * Validates an ABA routing number.
   */
  async validateAchRoutingNumber(
    requestParameters: ValidateAchRoutingNumberRequest
  ): Promise<ValidateAchRoutingNumber> {
    const response = await this.validateAchRoutingNumberRaw(requestParameters)
    return await response.value()
  }
}
